import { render } from "./EmailServiceParameter.vue?vue&type=template&id=5c1beb06&scoped=true"
import script from "./EmailServiceParameter.vue?vue&type=script&lang=ts"
export * from "./EmailServiceParameter.vue?vue&type=script&lang=ts"

import "./EmailServiceParameter.vue?vue&type=style&index=0&id=5c1beb06&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5c1beb06"

export default script